import { Close } from "@mui/icons-material";
import { FormControl, IconButton, MenuItem, Select, TextField, Tooltip, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import { STYLES } from "../../../provider-management/utils/customStyles";
import { PROVIDER_DETAIL_STYLES } from "../../styles";

export default function ContactDraftRow({
  canRemove,
  disableFields,
  row,
  options,
  valueLabel,
  onRowChange,
  onRemove,
  selectIdPrefix,
  inputIdPrefix,
}) {
  return (
    <div className="grid gap-3 md:grid-cols-[180px_minmax(0,1fr)_auto]">
      <div className="flex flex-col gap-1">
        <Typography className="text-xs font-medium" sx={PROVIDER_DETAIL_STYLES.fieldLabel}>Type</Typography>
        <FormControl size="small" className="w-full">
          <Select
            id={`${selectIdPrefix}-${row.localId}`}
            value={row.typeKey}
            onChange={(event) => onRowChange(row.localId, "typeKey", event.target.value)}
            displayEmpty
            disabled={disableFields}
            sx={STYLES.textField}
          >
            <MenuItem value="" disabled>Select an Option</MenuItem>
            {options.map((option) => <MenuItem key={option.key} value={option.key}>{option.label}</MenuItem>)}
          </Select>
        </FormControl>
      </div>
      <div className="flex flex-col gap-1">
        <Typography className="text-xs font-medium" sx={PROVIDER_DETAIL_STYLES.fieldLabel}>{valueLabel}</Typography>
        <TextField
          id={`${inputIdPrefix}-${row.localId}`}
          value={row.value}
          onChange={(event) => onRowChange(row.localId, "value", event.target.value)}
          placeholder={`Enter ${valueLabel.toLowerCase()}`}
          size="small"
          disabled={disableFields}
          sx={STYLES.textField}
        />
      </div>
      <div className="flex items-end pb-1">
        {canRemove ? (
          <Tooltip title="Remove row">
            <span>
              <IconButton size="small" onClick={() => onRemove(row)} sx={PROVIDER_DETAIL_STYLES.contactDangerButton}>
                <Close sx={PROVIDER_DETAIL_STYLES.contactDangerIcon} />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}
      </div>
    </div>
  );
}

ContactDraftRow.propTypes = {
  canRemove: PropTypes.bool,
  disableFields: PropTypes.bool,
  inputIdPrefix: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  onRowChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  row: PropTypes.object.isRequired,
  selectIdPrefix: PropTypes.string.isRequired,
  valueLabel: PropTypes.string.isRequired,
};

ContactDraftRow.defaultProps = {
  canRemove: true,
  disableFields: false,
};
